import config from 'config';
import { RSAA } from 'redux-api-middleware';


export const getDynamicSwitchGroupDiff = (codexVersion,dynamicSwitchGroupId) => {
  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/cat/codex-version/${codexVersion}/updated-dynamic-switch-groups/${dynamicSwitchGroupId}/dynamic-switch-options`,
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      types: [
        'DELTA_DSG_DETAIL_REQUEST',
        'DELTA_DSG_DETAIL_SUCCESS',
        'DELTA_DSG_DETAIL_FAILURE'
      ]
    }
  };
}
